import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import wl from "@/views/wl"
import Download from "@/views/Download"
import time from "@/views/time"
import xy from "@/views/xy"
import sjxs from "@/views/sjxs"
import mejz from "@/views/mejz"
import xyjj from "@/views/xyjj"
import jtjj from "@/views/jtjj"
import xycont from "@/views/xycont"
import jtcont from "@/views/jtcont"
import sm from "@/views/sm"
import yzlh from "@/views/yzlh"
import lh from "@/views/lh"
import xsbf from "@/views/xsbf"
import mebf from "@/views/mebf"
import zdzt from "@/views/zdzt"
import jzzt from "@/views/jzzt"
import zmzt from "@/views/zmzt"
import zlxz from "@/views/zlxz"
import tq from "@/views/tq"
import load from "@/views/load"
import zmyzlh from "@/views/zmyzlh"
import jzyzlh from "@/views/jzyzlh"
import tqjj from "@/views/tqjj"
import sgjj from "@/views/sgjj"
import tqcont from "@/views/tqcont"
import sgcont from "@/views/sgcont"
import album from "@/views/album"
import adetail from "@/views/adetail"
import search from "@/views/search"
Vue.use(Router)

//添加以下代码
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: "/wl",
      name : "wl",
      component : wl
    },
    {
      path: "/Download",
      name : "Download",
      component : Download
    },
    {
      path:"/time",
      name: "time",
      component : time
    },
    {
      path:"/xy",
      name:"xy",
      component:xy
    },
    {
      path:"/sjxs",
      name: "sjxs",
      component : sjxs
    },
    {
      path:"/mejz",
      name:"mejz",
      component:mejz
    },
    {
      path:"/xyjj",
      name:"xyjj",
      component:xyjj
    },
    {
      path:"/jtjj",
      name:"jtjj",
      component:jtjj
    },
    {
      path:"/xycont",
      name:"xycont",
      component:xycont
    },
    {
      path:"/jtcont",
      name:"jtcont",
      component:jtcont
    },
    {
      path:"/sm",
      name:"sm",
      component : sm
    },
    {
      path:"/yzlh",
      name:"yzlh",
      component:yzlh
    },
    {
      path:"/lh",
      name:"lh",
      component:lh
    },
    {
      path:"/xsbf",
      name:"xsbf",
      component:xsbf
    },
    {
      path: "/mebf",
      name: "mebf",
      component : mebf
    },
    {
      path:"/zdzt",
      name : "zdzt",
      component : zdzt
    },
    {
      path:"/jzzt",
      name:"jzzt",
      component:jzzt
    },
    {
      path:"/zmzt",
      name:"zmzt",
      component:zmzt
    },
    {
      path: "/zlxz",
      name:"zlxz",
      component:zlxz
    },
    {
      path:"/tq",
      name:"tq",
      component:tq
    },
    {
      path:"/load",
      name:"load",
      component:load
    },
    {
      path:"/zmyzlh",
      name:"zmyzlh",
      component:zmyzlh
    },
    {
      path:"/jzyzlh",
      name:"jzyzlh",
      component : jzyzlh
    },
    {
      path:"/tqjj",
      name:"tqjj",
      component:tqjj
    },
    {
      path:"/sgjj",
      name:"sgjj",
      component :sgjj
    },
    {
      path:"/sgcont",
      name:"sgcont",
      component:sgcont
    },
    {
      path:"/tqcont",
      name:"tqcont",
      component:tqcont
    },{
      path:"/album",
      name:"album",
      component:album
    },
    {
      path:"/adetail",
      name:"adetail",
      component:adetail
    },
    {
      path:"/search",
      name:"search",
      component:search
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js